import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, inject} from '@angular/core';
import {
    IActivitySurveryAnaluticsReq,
    IPagedData,
    IPagedSearch,
    ISurvey,
    ISurveyActivate,
    ISurveyCreate,
    ISurveyCreated,
} from '@evencel/models';
import {Observable, take} from 'rxjs';

export const SURVEY_URL = 'surveys';

@Injectable({providedIn: 'root'})
export class SurveyService {
    httpClient = inject(HttpClient);

    post(data: ISurveyCreate): Observable<ISurvey> {
        return this.httpClient.post<ISurvey>(SURVEY_URL, data);
    }

    patch(data: ISurvey): Observable<ISurvey> {
        const url = `${SURVEY_URL}/${data._id}`;
        return this.httpClient.patch<ISurvey>(url, data);
    }

    activate(data: ISurveyActivate): Observable<ISurvey> {
        const {active} = data;
        const url = `${SURVEY_URL}/${data._id}/activate`;
        return this.httpClient.patch<ISurvey>(url, {active});
    }

    uploadImage(_id: string, data: FormData): Observable<{url: string}> {
        return this.httpClient.post<{url: string}>(`${SURVEY_URL}/${_id}/upload-image`, data).pipe(take(1));
    }

    delete(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${SURVEY_URL}/${id}`);
    }

    restore(id: string): Observable<void> {
        return this.httpClient.delete<void>(`${SURVEY_URL}/${id}/restore`);
    }

    private searchParams(data: IPagedSearch) {
        const {active, direction} = data.sort;
        const {pageIndex, pageSize} = data.page;
        let params = new HttpParams();
        params = params.append('pageIndex', `${pageIndex}`);
        params = params.append('pageSize', `${pageSize}`);
        params = params.append('sort', active);
        params = params.append('order', direction);
        params = params.append('projection', data.projection || 'dataTable');
        return params;
    }

    search(data: IPagedSearch): Observable<IPagedData<ISurveyCreated>> {
        const params = this.searchParams(data);
        return this.httpClient.post<IPagedData<ISurveyCreated>>(`${SURVEY_URL}/search`, data.condition, {params});
    }

    getOne(id: string, projection = 'form'): Observable<ISurvey> {
        let params = new HttpParams();
        params = params.append('projection', projection);
        const url = `${SURVEY_URL}/${id}`;
        return this.httpClient.get<ISurvey>(url, {params});
    }

    get(data: IPagedSearch): Observable<IPagedData<ISurvey>> {
        const params = this.searchParams(data);
        return this.httpClient.get<IPagedData<ISurvey>>(SURVEY_URL, {params});
    }

    getAnalytics(req: IActivitySurveryAnaluticsReq) {
        const url = `${SURVEY_URL}/${req.survey._id}/analytics`;
        return this.httpClient.post<Record<string, unknown>[]>(url, req);
    }
}
